<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showModal && isSocketConnected">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content shadow-lg rounded-xl">
      <form [formGroup]="popupForm" (ngSubmit)="onSubmit()">
        <div class="modal-header border-0 px-6 py-4 gradient-header">
          <h5 class="modal-title text-xl font-semibold flex items-center">
             <img src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/osp_logo_dark.png" alt="Logo" style="height: 32px;text-align: center;" /> 
          </h5>
          <!-- <button type="button" class="btn-close-white" (click)="closeModal()">
            <span>&times;</span>
          </button> -->
        </div>

        <div class="modal-body px-6 py-4">
          <div class="mb-4 otpdiv">
            <p class="enter-code-label">Enter Verification Code</p>
            <div class="otp-wrapper flex justify-center space-x-2">
                <ng-otp-input class="otp-design" [config]="{length:6, isPasswordInput:true, allowNumbersOnly:true}" type="tel"
                               #ngOtpInput
                               (onInputChange)="OTPChecker($event)"
                               autocomplete="off"
                               (keydown.enter)="onClickVerify()"></ng-otp-input>
            </div>
            <div class="t-c">
              Didn’t receive the CODE?  <span class="timer" *ngIf="timeLeft !== 0 && isTimer">retry in {{ m ? m + " :" : "" }} {{ s ? s : "" }}</span> <a (click)="resendOTP()" [ngClass]="{'d-none': (timeLeft !== 0 && isTimer)}">Resend CODE</a>
          </div>
          </div>
        </div>

        <div class="modal-footer border-0 px-6 py-4">
          <button type="submit" class="btn btn-primary btn-lg w-100 rounded-pill gradient-button" (click)="onClickVerify()" [disabled]="!isVliadOtp">
             Verify CODE
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- ✅ Success Animation -->
<div *ngIf="showTick" class="tick-container">
  <div class="tick-circle">
    <div class="tick-mark"></div>
  </div>
  <div class="tick-message">Thank you for submitting the code.</div>
</div>

<!-- ❌ Failure Animation -->
<div *ngIf="showReject" class="tick-container">
  <div class="tick-circle error">
    <div class="cross-mark"></div>
  </div>
  <div class="tick-message error-message">Failed! Please try again.</div>
</div>
<!-- ⏳ Link Expired Animation -->
<div *ngIf="showLinkExpired" class="tick-container-expired center-screen">
  <div class="tick-circle expired">
    <div class="exclamation-mark">!</div>
  </div>
  <div class="tick-message expired-message h2 text-center mt-2">Link Expired! Please request a new Link.</div>
</div>



